import {
    AlignHorizontalCenterRounded,
    AlignHorizontalLeftRounded,
    AlignHorizontalRightRounded,
} from '@mui/icons-material';
import AttrField from './AttrField';
import ButtonField from './ButtonField';

function HorizontalAlign(props) {
    return (
        <AttrField
            dir="ltr"
            Component={ButtonField}
            exclusive
            options={[
                {
                    label: <AlignHorizontalLeftRounded />,
                    value: 'left',
                },
                {
                    label: <AlignHorizontalCenterRounded />,
                    value: 'center',
                },
                {
                    label: <AlignHorizontalRightRounded />,
                    value: 'right',
                },
            ]}
            {...props}
        />
    );
}

export default HorizontalAlign;
